// Tremor Raw Popover [v0.0.0]
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import * as PopoverPrimitives from "@radix-ui/react-popover";
import { cx } from "../../lib/utils";
const Popover = (props) => {
    return React.createElement(PopoverPrimitives.Root, Object.assign({}, props));
};
Popover.displayName = "Popover";
const PopoverTrigger = React.forwardRef((props, forwardedRef) => {
    return React.createElement(PopoverPrimitives.Trigger, Object.assign({ ref: forwardedRef }, props));
});
PopoverTrigger.displayName = "PopoverTrigger";
const PopoverAnchor = React.forwardRef((props, forwardedRef) => {
    return React.createElement(PopoverPrimitives.Anchor, Object.assign({ ref: forwardedRef }, props));
});
PopoverAnchor.displayName = "PopoverAnchor";
const PopoverClose = React.forwardRef((props, forwardedRef) => {
    return React.createElement(PopoverPrimitives.Close, Object.assign({ ref: forwardedRef }, props));
});
PopoverClose.displayName = "PopoverClose";
const PopoverContent = React.forwardRef((_a, forwardedRef) => {
    var { className, sideOffset = 10, side = "bottom", align = "center", collisionPadding, avoidCollisions, container } = _a, props = __rest(_a, ["className", "sideOffset", "side", "align", "collisionPadding", "avoidCollisions", "container"]);
    return (React.createElement(PopoverPrimitives.Portal, { container: container },
        React.createElement(PopoverPrimitives.Content, Object.assign({ ref: forwardedRef, sideOffset: sideOffset, side: side, align: align, collisionPadding: collisionPadding, avoidCollisions: true, className: cx(
            // base
            "onvo-max-h-[var(--radix-popper-available-height)] onvo-min-w-60 onvo-overflow-hidden onvo-rounded-2xl onvo-border-solid onvo-border onvo-p-2.5 onvo-text-sm onvo-shadow-md", 
            // border color
            "onvo-border-gray-200 dark:onvo-border-gray-800", 
            // text color
            "onvo-text-gray-900 dark:onvo-text-gray-50", 
            // background color
            "onvo-bg-white dark:onvo-bg-gray-950", 
            // transition
            "onvo-will-change-[transform,opacity]", "data-[state=closed]:onvo-animate-hide", "data-[state=open]:data-[side=bottom]:onvo-animate-slideDownAndFade data-[state=open]:data-[side=left]:onvo-animate-slideLeftAndFade data-[state=open]:data-[side=right]:onvo-animate-slideRightAndFade data-[state=open]:data-[side=top]:onvo-animate-slideUpAndFade", className), 
            // https://github.com/radix-ui/primitives/issues/1159
            onWheel: (event) => {
                event.stopPropagation();
                const isScrollingDown = event.deltaY > 0;
                if (isScrollingDown) {
                    event.currentTarget.dispatchEvent(new KeyboardEvent("keydown", { key: "ArrowDown" }));
                }
                else {
                    event.currentTarget.dispatchEvent(new KeyboardEvent("keydown", { key: "ArrowUp" }));
                }
            } }, props))));
});
PopoverContent.displayName = "PopoverContent";
export { Popover, PopoverAnchor, PopoverClose, PopoverContent, PopoverTrigger };
//# sourceMappingURL=Popover.js.map